import StockMovement from "@/components/StockMovement";

// Legacy route redirects to Stock Movement page in Sale mode.
// Stock Movement now uses the unified pivot UI (monthly × party).
export default function ItemSales({ companyContext }) {
  return <StockMovement companyContext={companyContext} initialMode="sale" />;
}
